import React, { Component } from 'react'
import format from 'date-fns/format'
import { connect } from 'react-redux'
import { Field, formValues, reduxForm, change } from 'redux-form'
import { startOfToday } from 'date-fns'

import { FormErrorNotification, RadioInputGroup, RadioInput, requiredField, trackEvent, FormLabel } from '@offerzen/pinata-shame'

import { DatePicker } from '@offerzen/pinata-shame/datepickers'
import aboutYou from '../../../assets/about-page.svg'

import Card from '../../components/Card'
import { nextOnboardingUrl, previousOnboardingUrl } from '../../helpers/onboardingSteps'
import { jobSearchStatuses } from '../../helpers/jobSearchStatusesHelper'
import CardFooterNav from '../../components/CardFooterNav/CardFooterNav'
import { updateCandidate as reduxUpdateCandidate } from '../../redux/modules/candidate'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'

import styles from './styles'

const validators = {
  required: requiredField('Required'),
}

const trackSelectedJobSearch = selection =>
  trackEvent('Candidate: profile action', {
    action: 'selected job search status',
    source: 'onboarding',
    selection,
  })

const trackProjectedStartDate = startDate =>
  trackEvent('Candidate: profile action', {
    action: 'added projected start date',
    source: 'onboarding',
    startDate,
  })

class JobSearchStatus extends Component {
  componentDidMount() {
    this.props.updateProgress(40)
    trackEvent('onboarding-job-search-status-accessed')
  }

  render() {
    const projStartDateField = 'estimated_job_search_start'
    const { candidateId, ...props } = this.props

    return (
      <Card title="Job search status" imageUrl={aboutYou} width={550}>
        <form onSubmit={props.handleSubmit}>
          <div className={styles.wrapper}>
            <If condition={props.error}>
              <FormErrorNotification text={props.error} />
            </If>

            <Field
              name="job_search_status"
              theme="primary"
              validate={validators.required}
              component={RadioInputGroup}
              label="Are you looking for a new job right now?"
              className={styles.radioGroup}
              onChange={event => {
                const isJobSearching = props.estimatedJobSearchStart && event.target.value !== 'not_looking'
                if (isJobSearching) {
                  props.clearField(props.form, projStartDateField)
                }
                trackSelectedJobSearch(event.target.value)
              }}>
              <For each="jobSearchStatus" of={jobSearchStatuses}>
                <RadioInput key={jobSearchStatus.id} value={jobSearchStatus.id} label={jobSearchStatus.label} />
              </For>
            </Field>
          </div>

          <If condition={props.jobSearchStatus === 'not_looking'}>
            <FormLabel htmlFor="startDate" label="Tell us when you’d like to start your job search" optional />
            <Field
              name={projStartDateField}
              placeholder="Select a date"
              formatter={date => (date ? format(date, 'DD MMMM YYYY') : undefined)}
              minDate={startOfToday()}
              component={DatePicker}
              className={styles.startDate}
              onChange={(_event, startDate) => trackProjectedStartDate(startDate)}
            />
          </If>
          <CardFooterNav
            navigateBack={() => this.props.history.push(previousOnboardingUrl(this.props.location.pathname))}
            loading={this.props.loading}
            className={styles.footer}
            theme="primary"
          />
        </form>
      </Card>
    )
  }
}

const mapStateToProps = state => {
  const {
    id,
    loading,
    user_id: userId,
    job_search_status: jobSearchStatus,
    estimated_job_search_start: estimatedJobSearchStart,
  } = state.candidate
  return {
    loading: loading || false,
    candidateId: id,
    user_id: userId,
    initialValues: {
      job_search_status: jobSearchStatus,
      estimated_job_search_start: estimatedJobSearchStart && jobSearchStatus === 'not_looking' ? estimatedJobSearchStart : null,
    },
  }
}

const mapDispatchToProps = dispatch => ({
  updateCandidate: (candidate, nextRoute) => dispatch(reduxUpdateCandidate(candidate, nextRoute)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  clearField: (form, field) => dispatch(change(form, field, null)),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  updateProfile: data => {
    const url = nextOnboardingUrl(ownProps.location.pathname)
    dispatchProps.updateCandidate(
      {
        candidate_id: stateProps.candidateId,
        ...data,
      },
      url,
    )
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(
  reduxForm({
    form: 'jobStatusForm',
    enableReinitialize: true,
    onSubmit: (values, _, props) => props.updateProfile(values),
  })(
    formValues({
      jobSearchStatus: 'job_search_status',
      estimatedJobSearchStart: 'estimated_job_search_start',
    })(JobSearchStatus),
  ),
)
